import {
    CoreDI,
    IEventManagerWithAsync, inject,
    injectable,
    IService,
    LoadPriorityName,
    SystemComponentType
} from '@gongxigames/framework/core';
import {SplashScreenWarper} from '@gongxigames/framework/slot/fragments/SplashScreenWarper';

@injectable()
export class SplashScreenService implements IService {
    public static NAME = 'SplashScreenService';
    public type: SystemComponentType = 'service';

    private readonly splashScreenWarper = new SplashScreenWarper();

    @inject(CoreDI.IEventManagerWithAsync)
    private readonly _eventManager!: IEventManagerWithAsync;

    public init(): void {
        this.splashScreenWarper.init(window.splashScreen, this._eventManager);

        this._eventManager.on('General.ResourcesLoading.LOADED_RESOURCES', (priority: LoadPriorityName) => {
            if (priority === 'before'){
                this.splashScreenWarper.hide();
            }
        }, this);
    }

    public destroy(): void {
        this.splashScreenWarper.hide();
    }
}
